// components
import useStableSearchParams from '@/hooks/useStableSearchParams';

function useLiveMode(): [boolean, (mode: boolean) => void] {
  const [searchParams, setSearchParams] = useStableSearchParams();

  const liveMode = searchParams.get('live') === '1';

  const setLiveModeInUrl = (mode: boolean) => {
    setSearchParams((prev: URLSearchParams) => {
      const nextParams = new URLSearchParams(prev);
      nextParams.set('live', mode ? '1' : '0');
      return nextParams;
    });
  };

  return [liveMode, setLiveModeInUrl];
}

export default useLiveMode;
